import React, { useState } from "react";

// Small local accordion wrapper used only by the Quick Review page —
// starts open when `defaultOpen` or `flagged` is true (something in the
// section looks incomplete), otherwise starts closed.
const CollapsibleSection = ({ title, flagged, defaultOpen, children }) => {
  const [open, setOpen] = useState(!!defaultOpen || !!flagged);

  return (
    <div className='quickReviewSection'>
      <div
        className='quickReviewSectionHeader'
        onClick={() => setOpen((prev) => !prev)}>
        <span>{title}</span>
        {flagged && <span className='quickReviewFlagDot' title='Missing info' />}
        <span className='quickReviewChevron'>{open ? "▾" : "▸"}</span>
      </div>
      {open && <div className='quickReviewSectionBody'>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
